import type { QuickSearchState } from '@/scopes/search/quick-search/infrastructure/store/store'

export function durationFilterOptionsSelector(state: QuickSearchState) {
  const options = state.filterOptions.Duration ?? []
  const selectedValues = state.filterSelection.Duration ?? []
  const selectedOptions = options.filter(option => selectedValues.includes(option.value)) ?? []
  return {
    options,
    selectedValues,
    selectedOptions,
  }
}

export function destinationFilterOptionsSelector(state: QuickSearchState) {
  const options = state.filterOptions.Destination ?? []
  return {
    options,
    selectedDestination: state.filterSelection.Destination,
  }
}

export function departureDateFilterOptionsSelector(state: QuickSearchState) {
  const options = state.filterOptions.DepartureDate ?? []
  return {
    options,
  }
}

export function transportTypeFilterOptionsSelector(state: QuickSearchState) {
  const options = state.filterOptions.TransportType ?? []
  return {
    options,
    selectedOption: state.filterSelection.TransportType,
  }
}

export function departureAirportFilterOptionsSelector(state: QuickSearchState) {
  const options = state.filterOptions.DepartureAirport ?? []
  const selectedValues = state.filterSelection.DepartureAirport ?? []
  const selectedOptions = options.filter(option => selectedValues.includes(option.value)) ?? []
  return {
    options,
    selectedValues,
    selectedOptions,
  }
}

export function participantsFilterSelector(state: QuickSearchState) {
  return state.filterSelection.Participants ?? []
}

export function isLoadingSelector(state: QuickSearchState) {
  return state.getQuickSearch.loading
}

export function totalResultsSelector(state: QuickSearchState) {
  return state.totalResults
}

export function searchLinkSelector(state: QuickSearchState) {
  return state.searchLink
}

export function publicationCodeSelector(state: QuickSearchState) {
  return state.publicationCode
}
